/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * One course to enroll, with extras pinned to this row (not floating).
 */
export interface HubSpotEnrollmentRow {
  /** HubSpot product slug stamped on Course.externalProductId */
  externalProductId: string;
  /** Modules that are not already on this course. Stored as extraModuleIds; accessible_module_ids becomes catalog union extras. Empty = full catalog. */
  extraModuleIds?: string[];
}
